import { render, staticRenderFns } from "./TaxEstimatorWidget.vue?vue&type=template&id=1cf547d3&scoped=true&"
import script from "./TaxEstimatorWidget.vue?vue&type=script&lang=ts&"
export * from "./TaxEstimatorWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TaxEstimatorWidget.vue?vue&type=style&index=0&id=1cf547d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf547d3",
  null
  
)

export default component.exports